import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Info, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, get, errMsg } from "@/lib/api";
import { useSeo } from "@/lib/layout";
import { PageHeader } from "@/admin/ui";
import { CrawlTab, GeneralTab, GeoTab, OrgTab } from "@/admin/SeoTabs";

const TABS = [["general", "General"], ["organizacion", "Organización"], ["rastreo", "Rastreo e indexación"], ["geo", "GEO e IA"]];

export default function SeoSettings() {
  const qc = useQueryClient();
  const { site } = useSeo();
  const { data } = useQuery({ queryKey: ["admin-seo"], queryFn: () => get("/admin/seo") });
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  const set = (p) => setF((x) => ({ ...x, ...p }));
  const save = useMutation({
    mutationFn: () => api.put("/admin/seo", f).then((r) => r.data),
    onSuccess: (d) => {
      setF(d);
      qc.setQueryData(["admin-seo"], d);
      qc.invalidateQueries({ queryKey: ["layout"] });
      toast.success("SEO y GEO guardados");
    },
    onError: (e) => toast.error(errMsg(e)),
  });
  if (!f) return <div className="py-20 grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  const saveBtn = (id) => (
    <Button onClick={() => save.mutate()} disabled={save.isPending} data-testid={`seo-save-btn${id}`}>{save.isPending && <Loader2 className="animate-spin" />}Guardar cambios</Button>
  );

  return (
    <div data-testid="admin-seo-page">
      <PageHeader kicker="Buscadores e IA" title="SEO y GEO" description="Todo lo que ven Google y los buscadores con IA, editable desde aquí. Lo de cada noticia se cambia en su editor.">
        {saveBtn("")}
      </PageHeader>
      <Tabs defaultValue="general">
        <TabsList className="h-auto flex-wrap justify-start bg-card border border-border p-1 mb-6">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} className="px-4 py-2" data-testid={`seo-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="general"><GeneralTab f={f} set={set} site={site} /></TabsContent>
        <TabsContent value="organizacion"><OrgTab f={f} set={set} /></TabsContent>
        <TabsContent value="rastreo"><CrawlTab f={f} set={set} /></TabsContent>
        <TabsContent value="geo"><GeoTab f={f} set={set} /></TabsContent>
      </Tabs>
      <div className="mt-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-t border-border pt-6">
        <p className="text-sm text-muted-foreground flex items-start gap-2 max-w-2xl">
          <Info className="h-4 w-4 mt-0.5 shrink-0" />
          Los cambios se aplican al momento en la web, el mapa del sitio, el RSS y llms.txt. Los archivos de la raíz (/robots.txt, /llms.txt y las etiquetas de verificación) se actualizan también cada vez que vuelves a publicar.
        </p>
        {saveBtn("-bottom")}
      </div>
    </div>
  );
}
